import { AUTH_BASE } from './apiConfig';
import {
  extractAccessToken,
  readErrorMessage,
  readResponseBody,
} from '../utils/apiResponse';

const getCsrfTokenFromCookie = () => {
  const match = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
};

export const ensureCsrfToken = async () => {
  const existing = getCsrfTokenFromCookie();
  if (existing) return existing;

  const response = await fetch(`${AUTH_BASE}/csrf-token`, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('CSRF 토큰을 가져오지 못했습니다.');
  }

  return getCsrfTokenFromCookie() || response.headers.get('X-CSRF-TOKEN');
};

export const login = async (username, password) => {
  const response = await fetch(`${AUTH_BASE}/login`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username, password }),
  });

  if (!response.ok) {
    throw new Error(await readErrorMessage(response));
  }

  const body = await readResponseBody(response);
  const token = extractAccessToken(body);
  if (!token) {
    throw new Error('로그인 응답에서 토큰을 찾을 수 없습니다.');
  }

  return token;
};

export const fetchAccessToken = async () => {
  const response = await fetch(`${AUTH_BASE}/me`, {
    credentials: 'include',
  });

  if (!response.ok) {
    return null;
  }

  const body = await readResponseBody(response);
  return extractAccessToken(body);
};

export const refreshAccessToken = async () => {
  const response = await fetch(`${AUTH_BASE}/refresh`, {
    method: 'POST',
    credentials: 'include',
  });

  if (!response.ok) {
    return null;
  }

  const body = await readResponseBody(response);
  return extractAccessToken(body);
};

export const logout = async () => {
  await fetch(`${AUTH_BASE}/logout`, {
    method: 'POST',
    credentials: 'include',
  });
};

export { getCsrfTokenFromCookie };
